import { getMarketTime as _getMarketTime } from '@sm/Flags';
import { sendTextError } from '@utils/sentry';

// eslint-disable-next-line import/prefer-default-export
export const getMarketTime = (marketplaceID, dt) =>
  _getMarketTime(marketplaceID, dt, sendTextError);

export const capitalizeStr = str => {
  /*
  Using a regular expression to find the first character of the string and the first character after each space
  Replacing those characters with their uppercase versions using toUpperCase()
  Input:
  "delivery fees"
  Output:
  "Delivery Fees"
   */
  return str.toLowerCase().replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase();
  });
};
